<template>
  <div id="printable" class="form-elements order" v-if="order">
    <div class="row">
      <div class="flex xs12" >
        <va-card >
          <form>
            <div class="row">
              <div class="flex md6 sm6 xs6">
                <h1 class="display-1">{{$t('tables.headings.ordersNumber')+' '+order.order_number + " ( "+  $t(`order.customerType.${order.customer_type ? order.customer_type : 'unknown'}`) + " )"}}</h1>
              </div>
              <div class="flex md6 sm6 xs6 alignRight">
                <va-button class="ma-0 mb-2 mt-1 mr-2 btn-to-hide" icon="va-icon fa fa-save" @click.prevent="saveOrder" type="button">{{ $t('order.saveOrder') }}</va-button>
                <va-button class="ma-0 mb-2 mt-1 mr-2 btn-to-hide" icon="va-icon fa fa-print" @click.prevent="printOrder" type="button">{{ $t('order.printOrder') }}</va-button>
                <va-button class="ma-0 mb-2 mt-1 mr-2 btn-to-hide" icon="va-icon fa fa-fax" @click.prevent="prepareSendToModula" type="button">{{ $t('order.sendModulaOrder') }}</va-button>
              </div>
            </div>
            <div class="row addresses">
              <div class="flex md4 sm6 xs12">
                <va-card v-if="order.shipping_address" :title="$t('order.address.shipping')">
                  <p><b>{{$t('order.address.name')}}:</b> {{order.shipping_address.name}}</p>
                  <p><b>{{$t('order.address.surname')}}:</b> {{order.shipping_address.surname}}</p>
                  <p><b>{{$t('order.address.email')}}:</b> <a :href="'mailto:'+order.shipping_address.email">{{order.shipping_address.email}}</a></p>
                  <p><b>{{$t('order.address.address')}}:</b> {{order.shipping_address.address}}</p>
                  <p><b>{{$t('order.address.city')+' ('+$t('order.address.province')+')'}}:</b> {{order.shipping_address.city + ' ('+order.shipping_address.province+')'}}</p>
                  <p><b>{{$t('order.address.zip')}}:</b> {{order.shipping_address.zip}}</p>
                  <p><b>{{$t('order.address.country')}}:</b> {{order.shipping_address.nation}}</p>
                  <p><b>{{$t('order.address.phone')}}:</b> {{order.shipping_address.phone}}</p>
                </va-card>
              </div>
              <div class="flex md4 sm6 xs12">
                <va-card v-if="order.billing_address" :title="$t('order.address.billing')">
                  <p><b>{{$t('order.address.name')}}:</b> {{order.billing_address.name}}</p>
                  <p><b>{{$t('order.address.surname')}}:</b> {{order.billing_address.surname}}</p>
                  <p><b>{{$t('order.address.email')}}:</b> <a :href="'mailto:'+order.billing_address.email">{{order.billing_address.email}}</a></p>
                  <p><b>{{$t('order.address.company')}}:</b> {{order.billing_address.company}}</p>
                  <p><b>{{$t('order.address.vat')}}:</b> {{order.billing_address.vat}}</p>
                  <p><b>{{$t('order.address.cf')}}:</b> {{order.billing_address.cf}}</p>
                  <p><b>{{$t('order.address.sdi')}}:</b> {{order.billing_address.sdi}}</p>                  
                  <p><b>{{$t('order.address.address')}}:</b> {{order.billing_address.address}}</p>
                  <p><b>{{$t('order.address.city')+' ('+$t('order.address.province')+')'}}:</b> {{order.billing_address.city + ' ('+order.billing_address.province+')'}}</p>
                  <p><b>{{$t('order.address.zip')}}:</b> {{order.billing_address.zip}}</p>
                  <p><b>{{$t('order.address.country')}}:</b> {{order.billing_address.nation}}</p>
                  <p><b>{{$t('order.address.phone')}}:</b> {{order.billing_address.phone}}</p>
                  <p><b>{{$t('order.address.fax')}}:</b> {{order.billing_address.fax}}</p>
                  <br>
                  <p v-if="order.billing_address.electronicInvoicing"><b>Il cliente ha richiesto l'emissione della fattura elettronica</b></p>

                </va-card>
              </div>
              <div class="flex md4 sm6 xs12">
                <va-card>
                  <va-select
                  :label="$t('order.status.status')"
                    v-model="orderStatus"
                    textBy="description"
                    :options="statusOptions"
                    :error="statusSelectError"
                  />
                </va-card>
                <va-card>
                  <va-input
                    :label="$t('order.trackingNumber')"
                    v-model="order.tracking"
                  />
                </va-card>
                <va-card>
                  <va-input
                    :label="$t('order.paymentMethod')"
                    :value="order.payment_method ? order.payment_method.title : $t('order.noPaymentMethod')"
                    :disabled="true"
                  />
                </va-card>
                <!-- <va-card>
                  <va-input
                    :label="$t('order.customerType.title')"
                    :value=" $t(`order.customerType.${order.customer_type ? order.customer_type : 'unknown'}`)"
                    :disabled="true"
                  />
                </va-card> -->
              </div>
            </div>
            <div class="row" id="table">
              <div class="flex md12 sm12 xs12">
                  <cartTable :order="order" :orderStatus="orderStatus.id" ref="cartTable"/>
              </div>
            </div>
            <div class="row">
              <div id="unset-height" class="flex md12 sm12 xs12">
                <notes></notes>
              </div>
            </div>
            <div class="row">
              <div class="flex md12 sm12 xs12">
                <va-button class="ma-0 mb-2 mt-1 mr-2 btn-to-hide" icon="va-icon fa fa-save" type="button">{{ $t('order.saveOrder') }}</va-button>
              </div>
            </div>
          </form>
          <div class="flex-center loader" id="loader" :class="['flex-center','loader',{loading:loading}]">
            <spring-spinner
                :animation-duration="2000"
                :size="60"
                :color="$themes.primary"
            />
          </div>
        </va-card>
      </div>
    </div>
    <div class="modals">
      <va-modal
        v-model="showModalChangeStatus"
        size="small"
        :title=" $t('order.modal.statusTitle')"
        :message=" $t('order.modal.statusText') "
        :okText=" $t('modal.confirm') "
        :cancelText=" $t('modal.cancel') "
        @ok="changeStatus"
        @cancel="abortChangeStatus"
      />
      <va-modal
        v-model="showConfirmModulaSend"
        size="small"
        :title=" $t('order.modal.sendModulaTitle')"
        :message=" $t('order.modal.sendModulaText') "
        :okText=" $t('modal.confirm') "
        :cancelText=" $t('modal.cancel') "
        @ok="sendModulaOrder"
        @cancel="abortSendModula"
      />
    </div>
  </div>
</template>

<script>
import notes from './notes/notes';
import cartTable from './cartTable.vue';
import { SpringSpinner } from 'epic-spinners'

export default {
  name: 'order',
  components:{
    notes,
    cartTable,
    SpringSpinner
  },
  data () {
    return {
      order: null,
      yetToSend: undefined,
      statusOptions: [
        {
          id: -1,
          description: this.$t('order.status.'+this.$orderStatus(-1))
        },
        {
          id: 0,
          description: this.$t('order.status.'+this.$orderStatus(0))
        },
        {
          id: 1,
          description: this.$t('order.status.'+this.$orderStatus(1))
        },
        {
          id: 2,
          description: this.$t('order.status.'+this.$orderStatus(2))
        },
        {
          id: 3,
          description: this.$t('order.status.'+this.$orderStatus(3))
        }
      ],
      orderStatus : {},
      statusSelectError: false,
      showModalChangeStatus: false,
      showConfirmModulaSend: false,
      loading: false,
    }
  },
  created(){
    this.getOrder();
    this.checkModulaOrder();
  },
  watch:{
    orderStatus:{
      deep: true,
      handler(val){
        if(val.id != this.order.status) this.validateStatus();
      }
    }
  },
  methods: {
    getOrder(){
      this.$axios.get('api/orders/getOrder',{params: {orderUuid: this.$route.params.uuid}})
      .then(axRes => {
        for(var i in axRes.data.items){
          if(axRes.data.items[i].product.prices.length){
            for(var j in axRes.data.items[i].product.prices){
              axRes.data.items[i].product.prices[j].discount = 0;
            }
          } else {
            axRes.data.items[i].product.prices.discount = this.$normalizePrice(axRes.data.items[i].product.prices.discount)
          }
        }
        this.order = axRes.data;
        this.orderStatus = {
          id: this.order.status,
          description: this.$t('order.status.'+this.$orderStatus(this.order.status))
        }
      }).catch(axErr => {
        this.showToast(
          this.$t('system.genericError'),
            {
              icon:'fa-warning',
              position: 'bottom-right',
              duration: 10000,
              fullWidth: false,
              className: 'vuestic-toast error'
            },
          )
        })
    },
    validateStatus(){
      if(!this.orderStatus){
        this.statusSelectError = true;
        return true;
      }
      this.statusSelectError = false;
      this.showModalChangeStatus = true;
    },
    abortChangeStatus(){
      this.orderStatus = {
        id: this.order.status,
        description: this.$t('order.status.'+this.$orderStatus(this.order.status))
      }
    },
    async prepareSendToModula(){
      if(this.yetToSend){
        this.sendModulaOrder();
      }else {
        this.showConfirmModulaSend= true;
      }
    },
    async sendModulaOrder(){
       this.loading = true;
      this.$axios.post('api/orders/send-to-modula', {orderUuid: this.$route.params.uuid, orderNumber: this.order.order_number })
      .then(axRes => {
        this.showToast(
        this.$t('order.sendModulaSuccess'),
          {
            icon:'fa-check',
            position: 'bottom-right',
            duration: 3000, 
            fullWidth: false,
            className: 'vuestic-toast'
          },
        );
         this.yetToSend = false;
         this.loading = false;
      }).catch(axErr => {
        this.loading = false;
        this.showToast(
          this.$t('order.sendModulaError'),
          {
            icon:'fa-warning',
            position: 'bottom-right',
            duration: 10000,
            fullWidth: false,
            className: 'vuestic-toast error'
          },
        )
      })
    },
    abortSendModula(){
      this.showConfirmModulaSend = false;
    },
    async checkModulaOrder(){
      const res = await this.$axios.post('/api/orders/check-modula-already-sent', {orderUuid: this.$route.params.uuid}); 
      this.yetToSend = !res.data.found;
    },
    changeStatus(){
      this.$axios.put('api/orders/updateOrderStatus',
        {
          orderUuid: this.order.uuid,
          status: this.orderStatus.id
        }
        ).then(axRes => {
        this.showToast(
        this.$t('order.updateSuccess'),
          {
            icon:'fa-check',
            position: 'bottom-right',
            duration: 3000, 
            fullWidth: false,
            className: 'vuestic-toast'
          },
        );
      }).catch(axErr => {
        this.showToast(
          this.$t('order.updateError'),
          {
            icon:'fa-warning',
            position: 'bottom-right',
            duration: 10000,
            fullWidth: false,
            className: 'vuestic-toast error'
          },
        )
      })
    },
    printOrder(){
      // let originalContents = document.body.innerHTML;
      // let printContents = document.getElementById('printable')
      // printContents.classList.add('printing')
      // document.body.innerHTML = printContents.parentElement.innerHTML;
      // window.print();
      // document.body.innerHTML = originalContents;
      // window.location.reload()
      window.open(this.$axios.defaults.baseURL + this.order.uuid, '_blank');
      return true;

    },
    async saveOrder(){
      this.loading = true;
      await this.$refs.cartTable.saveCart();
      this.$axios.put('api/orders/updateOrderTracking',{
        orderUuid: this.order.uuid,
        tracking: this.order.tracking
      })
      .then(axRes => {
        this.showToast(
            this.$t('order.successSaveTrack'),
            {
              icon:'fa-check',
              position: 'bottom-right',
              duration: 5000,
              fullWidth: false,
              className: 'vuestic-toast'
            },
          )
        this.loading = false;
      }).catch(axErr => {
        this.loading = false;
          this.showToast(
            this.$t('order.errorSavingTrack'),
            {
                icon:'fa-warning',
                position: 'bottom-right',
                duration: 5000,
                fullWidth: false,
                className: 'vuestic-toast'
            },
          )
      })
    }
  },
}
</script>

<style>

.alignRight{
  text-align: right;
}

.printing{
  width: 21cm;

}

.printing * {
  padding: 0 !important;
  color: #2b2b2b!important;
}


.printing .btn-to-hide{
  display: none
}

.printing .va-chat__body {
  height: unset!important;
}

.printing .va-chat{
  box-shadow: none;
}

.printing .va-chat__message-text{
  border-bottom:1px solid #2b2b2b;
}

.printing .va-chat__controls {
  display:none;
}

.printing .va-card{
  width:100%;
}

.printing > .row{
  width:21cm;
  flex: unset;
}
.printing .row .flex{
  width:7cm;
  flex-basis: unset;
  max-width:  unset;
}
.printing > .row .flex{
  width:21cm;
}

.printing .va-data-table_vuetable {
  width:21cm
}

.printing tr td:last-child{
  display:none;
}

.printing tr td:first-child{
  display:none;
}

.printing tr th:first-child{
  display:none;
}
  .printing tr th:last-child{
    display:none;
  }
.printing tr th,
.printing tr td{
  width:9cm!important;
}


.printing #loader {
  display: none;
}

.printing .addresses{
  min-height:10cm;
}

.printing .addresses .flex{
  width: 7cm;
}


.printing #table .va-card__body .row .flex{
  width:4cm;
}
.printing #table .va-card__body .row{
  width:4cm;
}

</style>